import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAward, FiShield } = FiIcons;

const FoundersSection = () => {
    useEffect(() => {
    // SEO: Add structured data for this section
    const sectionData = {
      "@context": "https://schema.org", "@type": "WebPageElement", "name": "Founders & Leadership",
      "description": "Meet the cybersecurity and AI experts leading our mission, with 40+ years of combined experience.",
      "hasPart": [
        { "@type": "Person", "name": "Johns Hopkins Alumnus", "jobTitle": "Co-Founder", "alumniOf": "Johns Hopkins University", "knowsAbout": ["Artificial Intelligence", "Cybersecurity"] },
        { "@type": "Person", "name": "Cyber Security Personality of the Year", "jobTitle": "Co-Founder", "award": "Cyber Security Personality of the Year", "knowsAbout": ["Cybersecurity", "National Security"] }
      ]
    };
    
    const scriptId = 'founders-structured-data';
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(sectionData);
  }, []);

  const founders = [
    { name: "Johns Hopkins Alumnus", credential: "Deep AI & Security Expertise", expertise: "15+ years building secure AI systems for enterprise and government.", image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop&crop=face" },
    { name: "Cyber Security Personality of the Year", credential: "Classified Experience", expertise: "25+ years in cybersecurity protecting critical infrastructure.", image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=300&h=300&fit=crop&crop=face" }
  ];

  return (
    <section className="py-20 bg-gray-50" itemScope itemType="https://schema.org/Person">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} viewport={{ once: true }} className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-6" itemProp="headline">Leadership You Can Trust</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">Our founders bring 40+ years of combined expertise in AI security and cyber defense, with a proven track record of protecting enterprise and government systems.</p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12">
          {founders.map((founder, index) => (
            <motion.div key={index} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: index * 0.2 }} viewport={{ once: true }} className="bg-white p-8 rounded-xl shadow-lg border border-gray-200">
              <div className="flex items-start space-x-6">
                <img src={founder.image} alt={founder.name} className="w-24 h-24 rounded-full object-cover border-4 border-teal-100" itemProp="image" />
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-1" itemProp="name">{founder.name}</h3>
                  <p className="text-teal-600 font-semibold mb-3" itemProp="jobTitle">{founder.credential}</p>
                  <p className="text-gray-600 leading-relaxed" itemProp="description">{founder.expertise}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FoundersSection;